export const IT_CONSULTATION_DATA = {
  title: "IT Consultations",
  description:
    "At QuantaRock Systems, we understand that navigating the ever-evolving landscape of technology can be challenging. Our IT Consultation services are designed to help you harness the power of technology to drive business growth, streamline operations, and enhance overall efficiency. With our expertise, we provide strategic guidance and practical solutions tailored to meet your unique business needs.",
  serviceTitle: "Our IT Consultation Services",
  serviceSubTitle: "Tailored Solutions to Drive Your Business Forward",
  detailSectionTitle: "Our Approach",
  detailSectionSubTitle:
    "A Proven Approach to IT Success: From Strategy to Execution",
  whyChooseUs: [
    {
      imgSrc: "experiencedProfessionals.webp",
      alt: "Experienced Professionals",
      title: "Experienced Professionals",
      description:
        "Our team of IT consultants comprises seasoned professionals with extensive experience across various industries. They bring a wealth of knowledge and a proven track record of delivering successful IT projects.",
    },
    {
      imgSrc: "customizedSolutions.webp",
      alt: "Customized Solutions",
      title: "Customized Solutions",
      description:
        "We recognize that each business is unique. Our consultants work closely with you to understand your specific requirements, challenges, and goals, crafting bespoke solutions that align with your business strategy.",
    },
    {
      imgSrc: "comprehensiveServices.webp",
      alt: "Comprehensive Services",
      title: "Comprehensive Services",
      description:
        "From IT infrastructure to cloud solutions, we deliver comprehensive IT services, optimizing your IT environment for peak performance and reliability.",
    },
  ],
  serviceSection: [
    {
      title: "Strategic IT Planning",
      description:
        "Develop actionable IT strategies that align with your business goals.",
      iconKey: "FaNetworkWired",
    },
    {
      title: "Cloud Solutions",
      description:
        "Leverage cloud technology for scalability and cost-efficiency.",
      iconKey: "FaCloud",
    },
    {
      title: "Network Design & Security",
      description:
        "Robust network solutions for seamless connectivity and protection.",
      iconKey: "FaShieldAlt",
    },
    {
      title: "Software Development",
      description: "Custom software solutions to streamline operations.",
      iconKey: "FaTools",
    },
    {
      title: "Data Analytics",
      description:
        "Unlock insights with powerful data solutions and analytics.",
      iconKey: "FaDatabase",
    },
    {
      title: "Disaster Recovery",
      description:
        "Prepare for the unexpected with business continuity strategies.",
      iconKey: "FaRedo",
    },
  ],
  howItWorks: [
    {
      step: "1",
      title: "Discovery and Analysis",
      description:
        "We begin by understanding your business goals, challenges, and current IT environment. This phase involves detailed discussions, assessments, and analysis to gather all necessary information.",
    },
    {
      step: "2",
      title: "Strategic Planning",
      description:
        "Based on our findings, we develop a comprehensive IT strategy that aligns with your business objectives. This plan includes actionable steps, timelines, and resource requirements.",
    },
    {
      step: "3",
      title: "Implementation and Support",
      description:
        "Our consultants work closely with your team to implement the recommended solutions. We provide ongoing support to ensure smooth execution and address any issues that may arise.",
    },
    {
      step: "4",
      title: "Continuous Improvement",
      description:
        "Technology is ever-evolving, and so are the needs of your business. We offer continuous monitoring, support, and optimization services to ensure your IT infrastructure remains aligned with your business goals.",
    },
  ],
  faq: [
    {
      question: "What is IT Consultation?",
      answer:
        "IT Consultation is a strategic service that helps businesses optimize their IT infrastructure, improve operational efficiency, and align technology with business goals.",
    },
    {
      question: "How can IT consulting help my business?",
      answer:
        "Our IT consultants help identify inefficiencies, recommend technology solutions, improve security, reduce costs, and ensure your IT environment supports business growth.",
    },
    {
      question: "What industries do you consult for?",
      answer:
        "We have experience across multiple industries including finance, healthcare, retail, manufacturing, and more. We tailor solutions to your specific industry needs.",
    },
    {
      question: "How long does an IT consultation engagement typically last?",
      answer:
        "Engagement duration varies based on project scope, ranging from short-term assessments (weeks) to long-term strategic partnerships (months or years).",
    },
  ],
};
export const RENTAL_HARDWARE = {
  title: "Rental Hardware",
  description:
    "Welcome to QuantaRock Systems, your trusted partner for all your IT hardware rental needs. We understand that in today’s fast-paced business environment, the need for flexible, cost-effective, and reliable IT solutions is paramount. Our rental IT hardware services are designed to provide you with the technology you need, when you need it, without the long-term commitment and high costs associated with purchasing new equipment.",
  serviceTitle: "Our Rental IT Hardware Offerings",
  serviceSubTitle: "Explore Our IT Hardware Rental Options",
  detailSectionTitle: "How It Works",
  detailSectionSubTitle: "Understanding Our Process",
  whyChooseUs: [
    {
      imgSrc: "cost.webp",
      alt: "Cost-Effective Solutions",
      title: "Cost-Effective Solutions",
      description:
        "Renting IT hardware allows you to access the latest technology at a fraction of the cost of purchasing new equipment. This helps you manage your budget more effectively and allocate resources to other critical areas of your business.",
    },
    {
      imgSrc: "man.webp",
      alt: "Flexibility and Scalability",
      title: "Flexibility and Scalability",
      description:
        "Our rental options are designed to be flexible and scalable to meet your changing business needs. Whether you need equipment for a short-term project or long-term deployment, we offer solutions that can be tailored to your requirements.",
    },
    {
      imgSrc: "latest-technology.webp",
      alt: "Access to the Latest Technology",
      title: "Access to the Latest Technology",
      description:
        "Stay ahead of the competition with access to the latest IT hardware. Our rental inventory is constantly updated to include the newest models and technologies, ensuring that you always have the best tools at your disposal.",
    },
    {
      imgSrc: "support.webp",
      alt: "Comprehensive Support",
      title: "Comprehensive Support",
      description:
        "When you rent from QuantaRock Systems, you receive more than just hardware. Our team of experts provides comprehensive support to ensure that your equipment is set up and running smoothly. We offer maintenance, troubleshooting, and technical assistance to keep your operations on track.",
    },
    {
      imgSrc: "obsolescence.webp",
      alt: "Reduced Obsolescence",
      title: "Reduced Obsolescence",
      description:
        "Technology evolves rapidly, and owning IT hardware can lead to obsolescence. Renting allows you to upgrade your equipment as needed, without the burden of outdated technology.",
    },
    {
      imgSrc: "operations.webp",
      alt: "Enhanced Operational Efficiency",
      title: "Enhanced Operational Efficiency",
      description:
        "Renting IT hardware from QuantaRock Systems streamlines your operations by eliminating the hassle of procurement, maintenance, and asset management. Our ready-to-use equipment ensures minimal downtime, allowing you to focus on your core business objectives while we handle the logistics and upkeep.",
    },
  ],
  serviceSection: [
    {
      title: "Servers",
      description:
        "High-performance servers for various applications, including data centers, cloud computing, and virtualization.",
      iconKey: "FaServer",
    },
    {
      title: "Networking Equipment",
      description:
        "Switches, routers, and other networking devices to ensure seamless connectivity and communication.",
      iconKey: "FaNetworkWired",
    },
    {
      title: "Storage Solutions",
      description:
        " Reliable storage options, including NAS, SAN, and DAS systems, to meet your data management needs.",
      iconKey: "FaDatabase",
    },
    {
      title: "Peripherals and Accessories",
      description:
        "Monitors, keyboards, mice, and other accessories to complement your IT setup.",
      iconKey: "FaKeyboard",
    },
    {
      title: "Computing Devices",
      description:
        "Desktops, laptops, and workstations to empower your workforce with the tools they need to succeed.",
      iconKey: "FaDesktop",
    },
    {
      title: "Customizable Solutions",
      description:
        "Tailored IT hardware to meet your unique business needs, offering specialized equipment and custom setups for optimal performance.",
      iconKey: "FaCogs",
    },
  ],
  howItWorks: [
    {
      step: "1",
      title: "Consultation",
      description:
        "Contact us to discuss your IT hardware needs. Our team will help you identify the best rental options based on your requirements and budget.",
    },
    {
      step: "2",
      title: "Quote and Agreement",
      description:
        "We provide a detailed quote and rental agreement outlining the terms and conditions. Once agreed upon, we proceed with the rental process.",
    },
    {
      step: "3",
      title: "Delivery and Setup",
      description:
        "We deliver the hardware to your location and assist with the setup and configuration to ensure everything is ready for use.",
    },
    {
      step: "4",
      title: "Ongoing Support",
      description:
        "Our support team is available to assist you throughout the rental period, providing maintenance, troubleshooting, and technical support as needed.",
    },
  ],
  faq: [
    {
      question: "What types of IT hardware can I rent from QuantaRock?",
      answer:
        "We offer servers, networking equipment, storage solutions, peripherals, and computing devices. All hardware is regularly maintained and updated.",
    },
    {
      question: "What are the rental terms and flexibility options?",
      answer:
        "We offer flexible rental periods from short-term projects to long-term deployments. Terms can be customized based on your business needs.",
    },
    {
      question: "Is technical support included with hardware rentals?",
      answer:
        "Yes, all rentals include comprehensive technical support, maintenance, and troubleshooting throughout your rental period.",
    },
    {
      question: "Can I upgrade or replace rental equipment?",
      answer:
        "Absolutely. You can upgrade your equipment as your needs change, or replace any equipment that becomes outdated without penalty.",
    },
  ],
};
export const SECURITY_AS_SERVICE = {
  title: "Security as a Service",
  description:
    "At QuantaRock Systems, we recognize the critical importance of robust security measures in today's digital landscape. Our Security as a Service (SECaaS) offerings are designed to provide comprehensive protection for your IT infrastructure, data, and applications. By leveraging advanced technologies and industry best practices, we ensure that your business remains secure against evolving cyber threats.",
  serviceTitle: "Our Security as a Service Offerings",
  serviceSubTitle: "Explore Our Security-as-a-Service Solutions",
  detailSectionTitle: "Our Approach",
  detailSectionSubTitle: "Understanding Our Process",
  whyChooseUs: [
    {
      imgSrc: "security.webp",
      alt: "Expert Security Professionals",
      title: "Expert Security Professionals",
      description:
        "Our team of security experts possesses extensive experience in various domains of cybersecurity. They stay ahead of the latest threats and vulnerabilities to provide proactive protection for your organization.",
    },
    {
      imgSrc: "solutions.webp",
      alt: "Tailored Security Solutions",
      title: "Tailored Security Solutions",
      description:
        "We understand that security needs vary across different businesses. Our solutions are customized to address your specific requirements, ensuring optimal protection without compromising performance.",
    },
    {
      imgSrc: "coverage.webp",
      alt: "Comprehensive Coverage",
      title: "Comprehensive Coverage",
      description:
        "From network security and endpoint protection to cloud security and compliance management, our SECaaS offerings cover all aspects of your security landscape.",
    },
  ],
  serviceSection: [
    {
      title: "Endpoint Protection",
      description:
        "Safeguard your devices from malware, ransomware, and other threats. Our endpoint protection solutions provide real-time monitoring, threat detection, and automated response to ensure your devices are secure.",
      iconKey: "FaShieldAlt",
    },
    {
      title: "Network Security",
      description:
        "Protect your network infrastructure from unauthorized access, data breaches, and cyber attacks. Our network security services include firewall management, intrusion detection and prevention, and secure VPN solutions.",
      iconKey: "FaNetworkWired",
    },
    {
      title: "Cloud Security",
      description:
        "Ensure the security of your cloud environments with our comprehensive cloud security services. We provide security assessments, configuration management, and continuous monitoring to protect your cloud assets.",
      iconKey: "FaCloud",
    },
    {
      title: "Data Security",
      description:
        " Protect your sensitive data from theft and unauthorized access. Our data security solutions include encryption, data loss prevention, and secure data storage to ensure the confidentiality and integrity of your information.",
      iconKey: "FaLock",
    },
    {
      title: "Compliance Management",
      description:
        "Stay compliant with industry regulations and standards. We help you navigate complex compliance requirements, including GDPR, HIPAA, and PCI DSS, ensuring that your security practices meet the necessary criteria.",
      iconKey: "FaBalanceScale",
    },
    {
      title: "Threat Intelligence",
      description:
        "Leverage our threat intelligence services to stay informed about emerging threats. We provide actionable insights and timely alerts to help you mitigate risks before they impact your business.",
      iconKey: "FaBrain",
    },
  ],
  howItWorks: [
    {
      step: "1",
      title: "Assessment and Planning",
      description:
        "We start by conducting a thorough assessment of your current security posture. Based on our findings, we develop a tailored security strategy that addresses your unique risks and challenges.",
    },
    {
      step: "2",
      title: "Implementation and Integration",
      description:
        "Our team works closely with you to implement the recommended security measures. We ensure seamless integration with your existing systems and processes for optimal protection.",
    },
    {
      step: "3",
      title: "Continuous Monitoring and Management",
      description:
        "Security is an ongoing process. We provide continuous monitoring and management of your security environment to detect and respond to threats in real-time.",
    },
    {
      step: "4",
      title: "Regular Updates and Improvements",
      description:
        "As the threat landscape evolves, so do our solutions. We regularly update and improve our security offerings to ensure you stay protected against the latest threats.",
    },
  ],
  faq: [
    {
      question: "What is Security as a Service (SECaaS)?",
      answer:
        "SECaaS is a cloud-based security service that provides comprehensive protection against cyber threats, including endpoint protection, network security, and compliance management.",
    },
    {
      question: "How does SECaaS differ from traditional security solutions?",
      answer:
        "SECaaS is managed and maintained by QuantaRock, eliminating the need for on-premise security infrastructure while providing 24/7 monitoring and threat response.",
    },
    {
      question: "What compliance standards does your SECaaS cover?",
      answer:
        "Our SECaaS helps meet GDPR, HIPAA, PCI DSS, ISO 27001, and other industry compliance requirements.",
    },
    {
      question: "Is there downtime during security implementation?",
      answer:
        "No. We implement security solutions seamlessly with minimal disruption to your business operations.",
    },
  ],
};
export const COLOCATION_SERVICES = {
  title: "Colocation Services",
  description:
    "QuantaRock delivers secure, scalable colocation with rack space, reliable power, advanced cooling, and carrier-neutral connectivity. Our teams support dedicated deployments in Indore, Pune, Bangalore, and across India—helping businesses improve uptime while reducing infrastructure overhead.",
  serviceTitle: "Our Colocation Offerings",
  serviceSubTitle: "Explore Our Colocation Solutions Options",
  detailSectionTitle: "How It Works",
  detailSectionSubTitle: "Understanding Our Process",
  whyChooseUs: [
    {
      imgSrc: "dataCenter.webp",
      alt: "State-of-the-Art Data Centers",
      title: "State-of-the-Art Data Centers",
      description:
        "Our data centers are equipped with the latest technology and infrastructure to ensure optimal performance and security. With robust power and cooling systems, advanced fire suppression, and 24/7 monitoring, your equipment is in safe hands.",
    },
    {
      imgSrc: "enhancedSecurity.webp",
      alt: "Enhanced Security",
      title: "Enhanced Security",
      description:
        "Security is our top priority. Our facilities feature multi-layered security measures, including biometric access controls, surveillance cameras, and security personnel, ensuring that your data and hardware are protected at all times.",
    },
    {
      imgSrc: "scalability.webp",
      alt: "Scalability",
      title: "Scalability",
      description:
        "Our colocation services are designed to grow with your business. Whether you need a single rack or an entire cage, we offer flexible solutions that can be easily scaled to meet your evolving needs.",
    },
    {
      imgSrc: "networkConnectivity.webp",
      alt: "Network Connectivity",
      title: "Network Connectivity",
      description:
        "Benefit from our high-speed, low-latency network connectivity. We provide access to multiple carriers and ISPs, ensuring redundancy and reliable internet access for your critical operations.",
    },
    {
      imgSrc: "expertSupport.webp",
      alt: "Expert Support",
      title: "Expert Support",
      description:
        "Our team of experienced professionals is available around the clock to assist with any technical issues or requirements. From remote hands services to on-site support, we ensure your infrastructure runs smoothly.",
    },
    {
      imgSrc: "costSaving.webp",
      alt: "Cost Saving",
      title: "Cost Saving",
      description:
        "Reduce capital expenditure and operational costs by leveraging our colocation services. Eliminate the need for building and maintaining your own data center, allowing you to allocate resources more effectively.",
    },
  ],
  serviceSection: [
    {
      title: "Rack Space",
      description:
        "Choose from quarter, half, and full rack options to accommodate your server and equipment needs.",
      iconKey: "FaServer",
    },
    {
      title: "Private Cages",
      description:
        "Secure private cages for larger deployments, offering enhanced security and isolation.",
      iconKey: "FaLock",
    },
    {
      title: "Remote Hands",
      description:
        "Our remote hands services provide on-site technical assistance, including equipment installation, troubleshooting, and maintenance.",
      iconKey: "FaTools",
    },
    {
      title: "Power Solutions",
      description:
        "Redundant power systems with backup generators and UPS to ensure uninterrupted power supply.",
      iconKey: "FaPlug",
    },
    {
      title: "Cooling Solutions",
      description:
        " Advanced cooling systems to maintain optimal temperatures and prevent overheating.",
      iconKey: "FaSnowflake",
    },
    {
      title: "Compliance",
      description:
        "Our facilities comply with industry standards and regulations, ensuring your data and operations meet compliance requirements.",
      iconKey: "FaBalanceScale",
    },
  ],
  howItWorks: [
    {
      step: "1",
      title: "Consultation",
      description:
        "Contact us to discuss your colocation needs. Our team will help you determine the best solution based on your requirements and budget.",
    },
    {
      step: "2",
      title: "Setup",
      description:
        "We assist with the setup and installation of your equipment in our data center, ensuring everything is configured correctly.",
    },
    {
      step: "3",
      title: "Monitoring and Support",
      description:
        "We provide 24/7 monitoring, proactive maintenance, and support to keep your infrastructure running smoothly.",
    },
    {
      step: "4",
      title: "Reporting",
      description:
        "Receive regular reports on the performance and status of your equipment, keeping you informed and in control.",
    },
  ],
  faq: [
    {
      question: "What is data center colocation?",
      answer:
        "Data center colocation is a service that provides secure rack space, power, cooling and network connectivity for your servers within a shared data center facility.",
    },
    {
      question: "Do you provide remote hands and on-site support?",
      answer:
        "Yes — QuantaRock offers remote hands services and 24/7 technical support for installations, troubleshooting and maintenance.",
    },
    {
      question: "What connectivity options are available?",
      answer:
        "We provide carrier-neutral connectivity with multiple ISPs and cross-connect options to meet redundancy and low-latency requirements.",
    },
    {
      question: "How do you ensure security and compliance?",
      answer:
        "Our facilities use biometric access, CCTV, redundant power/cooling, fire suppression, and adhere to industry compliance standards; we can support audits and certifications.",
    },
    {
      question: "Colocation vs cloud hosting — which should I choose?",
      answer:
        "Colocation gives you full control over your own hardware and predictable long-term costs, making it ideal for stable, compliance-sensitive workloads. Cloud hosting is better for variable or fast-growing workloads that need to scale in minutes. Many businesses use both — colocating stable core systems while using cloud for bursty demand.",
    },
    {
      question: "What is a data center Tier, and what Tier is your facility?",
      answer:
        "Data center Tiers (1-4) rate a facility's power and cooling redundancy, from Tier 1 (basic, no redundancy) to Tier 4 (fully fault-tolerant). QuantaRock's facilities are built to Tier 3 standards, meaning any component can be maintained without disrupting your operations, with 99.982% guaranteed uptime.",
    },
    {
      question: "What should I ask before choosing a colocation provider?",
      answer:
        "Key questions include: what's the actual power/cooling redundancy, is any Tier claim formally certified, what's their downtime track record, what connectivity and compliance certifications do they offer, and is pricing fully transparent with no hidden power or bandwidth fees. We're happy to walk through all of these with you directly.",
    },
  ],
};
export const DEDICATED_SERVERS = {
  title: "Dedicated Server Services",
  description:
    "Welcome to QuantaRock Systems, your trusted provider of high-performance dedicated server services. In the ever-evolving digital landscape, having a reliable and powerful server is crucial for businesses to run their applications and manage their data efficiently. Our dedicated server services are designed to offer you unparalleled performance, security, and flexibility.",
  serviceTitle: "Our Dedicated Server Offerings",
  serviceSubTitle: "Explore Our Dedicated Server Offerings",
  detailSectionTitle: "How It Works",
  detailSectionSubTitle: "Understanding Our Process",
  whyChooseUs: [
    {
      imgSrc: "highPerformance.webp",
      alt: "High Performance",
      title: "High Performance",
      description:
        "Our dedicated servers are equipped with the latest hardware and technology to ensure maximum performance and reliability. Whether you need to run resource-intensive applications or manage large databases, our servers can handle it all.",
    },
    {
      imgSrc: "fullControl.webp",
      alt: "Full Control",
      title: "Full Control",
      description:
        "With a dedicated server, you have complete control over your server environment. Customize the server to meet your specific needs, install any software you require, and manage your resources without any restrictions.",
    },
    {
      imgSrc: "serverSecurity.webp",
      alt: "Enhanced Security",
      title: "Enhanced Security",
      description:
        "Security is a top priority at QuantaRock Systems. Our dedicated servers come with advanced security features, including DDoS protection, firewalls, and regular security updates to keep your data safe and secure.",
    },
    {
      imgSrc: "scalability.webp",
      alt: "Scalability",
      title: "Scalability",
      description:
        " As your business grows, your server needs may change. Our dedicated server solutions are highly scalable, allowing you to upgrade your resources and capabilities as needed without any downtime.",
    },
    {
      imgSrc: "24support.webp",
      alt: "24/7 Support",
      title: "24/7 Support",
      description:
        "Our team of experienced professionals is available around the clock to assist you with any technical issues or questions you may have. From setup to maintenance, we provide comprehensive support to ensure your server runs smoothly.",
    },
    {
      imgSrc: "costSaving.webp",
      alt: "Cost-Effective",
      title: "Cost-Effective",
      description:
        "With our competitive pricing and flexible plans, you can enjoy the benefits of a dedicated server without breaking the bank. Our solutions are designed to provide excellent value for your investment.",
    },
  ],
  serviceSection: [
    {
      title: "Customizable Servers",
      description:
        "Choose from a range of server configurations to find the perfect match for your business needs. Customize CPU, RAM, storage, and more to build your ideal server.",
      iconKey: "FaServer",
    },
    {
      title: "Managed and Unmanaged Options",
      description:
        "Whether you prefer to manage your server on your own or require our expert management services, we offer both options to suit your needs.",
      iconKey: "FaUserShield",
    },
    {
      title: "High Availability",
      description:
        "Ensure maximum uptime with our high-availability solutions. Our data centers are equipped with redundant power and network connections to keep your server online and accessible at all times.",
      iconKey: "FaHeartbeat",
    },
    {
      title: "Advanced Networking",
      description:
        "Benefit from our high-speed, low-latency network connections, multiple carrier options, and robust network infrastructure to support your online operations.",
      iconKey: "FaNetworkWired",
    },
    {
      title: "Backup and Recovery",
      description:
        "Protect your data with our reliable backup and disaster recovery solutions. Regular backups and quick recovery options ensure your data is safe and can be restored quickly in case of any issues.",
      iconKey: "FaDatabase",
    },
    {
      title: "Compliance",
      description:
        "Our dedicated servers comply with industry standards and regulations, ensuring your operations meet compliance requirements.",
      iconKey: "FaBalanceScale",
    },
  ],
  howItWorks: [
    {
      step: "1",
      title: "Consultation",
      description:
        "Contact us to discuss your server needs. Our team will help you determine the best solution based on your requirements and budget.",
    },
    {
      step: "2",
      title: "Setup",
      description:
        "We assist with the setup and configuration of your dedicated server, ensuring everything is optimized for your specific needs.",
    },
    {
      step: "3",
      title: "Monitoring and Support",
      description:
        "Our 24/7 monitoring and support services ensure your server is always up and running. We provide proactive maintenance and troubleshooting to prevent issues before they arise.",
    },
    {
      step: "4",
      title: "Reporting",
      description:
        "Receive regular reports on the performance and status of your server, keeping you informed and in control.",
    },
  ],
  faq: [
    {
      question: "What is a Dedicated Server?",
      answer:
        "A dedicated server is a physical server exclusively for your use, providing full control, maximum performance, and security.",
    },
    {
      question:
        "What is the difference between dedicated servers and shared hosting?",
      answer:
        "Dedicated servers offer exclusive resources, better performance, full control, and higher security compared to shared hosting where resources are shared among multiple users.",
    },
    {
      question: "Can I customize my dedicated server?",
      answer:
        "Yes, you can customize CPU, RAM, storage, OS, and software. Our team helps you configure the perfect server for your needs.",
    },
    {
      question: "Do you offer managed or unmanaged options?",
      answer:
        "We offer both managed and unmanaged options. Managed includes 24/7 monitoring, updates, and support. Unmanaged gives you full control.",
    },
    {
      question: "VPS vs dedicated server — which should I choose?",
      answer:
        "A VPS is more cost-effective and can be resized in minutes, making it ideal for most growing businesses. A dedicated server gives you an entire physical machine with zero resource sharing, which matters if you run consistently high-traffic workloads or have compliance requirements demanding full physical isolation.",
    },
  ],
};
export const VPS_SERVICES = {
  title: "VPS Services",
  description:
    "Welcome to QuantaRock Systems, your premier provider of Virtual Private Server (VPS) services. In today's digital age, having a reliable and scalable hosting solution is essential for businesses of all sizes. Our VPS services are designed to offer you the power and flexibility of dedicated servers at a fraction of the cost.",
  serviceTitle: "Our VPS Offerings",
  serviceSubTitle: "Explore Our VPS Offerings Options",
  detailSectionTitle: "How It Works",
  detailSectionSubTitle: "Understanding Our Process",
  whyChooseUs: [
    {
      imgSrc: "vpsPerformance.webp",
      alt: "High Performance",
      title: "High Performance",
      description:
        "Our VPS solutions are powered by high-performance hardware and optimized for maximum speed and reliability. Whether you're running a website, an application, or a development environment, our VPS can handle your needs efficiently.",
    },
    {
      imgSrc: "scalability.webp",
      alt: "Scalability",
      title: "Scalability",
      description:
        "Easily scale your resources as your business grows. With QuantaRock Systems, you can upgrade your CPU, RAM, and storage without any downtime, ensuring your services remain uninterrupted.",
    },
    {
      imgSrc: "rootAccess.webp",
      alt: "Full Root Access",
      title: "Full Root Access",
      description:
        "Gain complete control over your server environment with full root access. Customize your server to meet your specific needs and install any software you require.",
    },
    {
      imgSrc: "enhancedSecurity.webp",
      alt: "Enhanced Security",
      title: "Enhanced Security",
      description:
        "Security is a top priority at QuantaRock Systems. Our VPS solutions come with robust security features, including firewalls, DDoS protection, and regular security updates to keep your data safe.",
    },
    {
      imgSrc: "customerCare.webp",
      alt: "24/7 Support",
      title: "24/7 Support",
      description:
        "Our experienced support team is available around the clock to assist you with any technical issues or questions you may have. We are committed to ensuring your VPS runs smoothly at all times.",
    },
    {
      imgSrc: "note.webp",
      alt: "Cost-Effective",
      title: "Cost-Effective",
      description:
        "Enjoy the benefits of dedicated server performance without the high costs. Our VPS plans are competitively priced, offering excellent value for your investment.",
    },
  ],
  serviceSection: [
    {
      title: "Customizable Plans",
      description:
        "Choose from a range of VPS plans tailored to different needs and budgets. Customize your plan by selecting the CPU, RAM, and storage that best suit your requirements.",
      iconKey: "FaServer",
    },
    {
      title: "Managed and Unmanaged Options",
      description:
        "Whether you prefer to manage your VPS yourself or need our expert management services, we offer both options to cater to your needs.",
      iconKey: "FaUserShield",
    },
    {
      title: "SSD Storage",
      description:
        "Experience faster data access and improved performance with SSD storage, available in all our VPS plans.",
      iconKey: "FaHdd",
    },
    {
      title: "Regular Backups",
      description:
        "Protect your data with our reliable backup solutions. We offer regular backups and quick recovery options to ensure your data is safe and can be restored quickly in case of any issues.",
      iconKey: "FaSave",
    },
    {
      title: "High Availability",
      description:
        "Ensure maximum uptime with our high-availability solutions. Our data centers are equipped with redundant power and network connections to keep your VPS online and accessible at all times.",
      iconKey: "FaHeartbeat",
    },
    {
      title: "Advanced Networking",
      description:
        "Benefit from our high-speed, low-latency network connections, multiple carrier options, and robust network infrastructure to support your online operations.",
      iconKey: "FaNetworkWired",
    },
  ],
  howItWorks: [
    {
      step: "1",
      title: "Consultation",
      description:
        "Contact us to discuss your VPS needs. Our team will help you determine the best solution based on your requirements and budget.",
    },
    {
      step: "2",
      title: "Setup",
      description:
        "We assist with the setup and configuration of your VPS, ensuring everything is optimized for your specific needs.",
    },
    {
      step: "3",
      title: "Monitoring and Support",
      description:
        "Our 24/7 monitoring and support services ensure your VPS is always up and running. We provide proactive maintenance and troubleshooting to prevent issues before they arise.",
    },
    {
      step: "4",
      title: "Reporting",
      description:
        "Receive regular reports on the performance and status of your VPS, keeping you informed and in control.",
    },
  ],
  faq: [
    {
      question: "What is a VPS?",
      answer:
        "A Virtual Private Server (VPS) is a virtual machine that provides dedicated resources within a physical server, offering better performance than shared hosting at lower cost than dedicated servers.",
    },
    {
      question: "Is VPS suitable for my growing business?",
      answer:
        "Yes, VPS is highly scalable. You can upgrade CPU, RAM, and storage as your business grows without downtime.",
    },
    {
      question: "What operating systems are available?",
      answer:
        "We offer Linux, Windows, and other OS options. Choose the one that best fits your application requirements.",
    },
    {
      question: "How is VPS security managed?",
      answer:
        "We provide firewalls, DDoS protection, regular security updates, and optional managed security services.",
    },
    {
      question: "VPS vs dedicated server — which should I choose?",
      answer:
        "A VPS is more cost-effective and can be resized in minutes, making it ideal for most growing businesses. A dedicated server gives you an entire physical machine with zero resource sharing, which matters if you run consistently high-traffic workloads or have compliance requirements demanding full physical isolation.",
    },
  ],
};
export const CLOUD_SERVICES = {
  title: "Cloud Services",
  description:
    "Welcome to QuantaRock Systems, your trusted partner for comprehensive cloud services. In the rapidly evolving digital landscape, cloud computing has become a cornerstone for businesses looking to enhance agility, scalability, and efficiency. Our cloud services are designed to provide you with flexible and secure solutions tailored to your specific needs.",
  serviceTitle: "Our Cloud Offerings",
  serviceSubTitle: "Explore Our Cloud Offerings Options",
  detailSectionTitle: "How It Works",
  detailSectionSubTitle: "Understanding Our Process",
  whyChooseUs: [
    {
      imgSrc: "cloudAvailability.webp",
      alt: "High Availability",
      title: "High Availability",
      description:
        "Enjoy uninterrupted access to your applications and data with our highly available cloud infrastructure. Our redundant systems and data centers ensure maximum uptime and reliability for your operations.",
    },
    {
      imgSrc: "cloudScalability.webp",
      alt: "Scalability",
      title: "Scalability",
      description:
        "Our cloud solutions allow you to scale resources up or down based on your business requirements. Whether you experience sudden spikes in demand or need to streamline operations, our cloud infrastructure adapts seamlessly to your needs.",
    },
    {
      imgSrc: "cloudFlexibility.webp",
      alt: "Flexibility",
      title: "Flexibility",
      description:
        "Choose from a variety of cloud models, including public, private, and hybrid clouds, to match your specific requirements. Customize your cloud environment to meet your unique business needs and goals.",
    },
    {
      imgSrc: "cloudSecurity.webp",
      alt: "Security",
      title: "Security",
      description:
        "At QuantaRock Systems, we prioritize the security of your data. Our cloud services come with robust security measures, including encryption, firewalls, and regular security audits, ensuring your data remains protected at all times.",
    },
    {
      imgSrc: "cloudSupport.webp",
      alt: "Expert Support",
      title: "Expert Support",
      description:
        "Our experienced cloud professionals are available 24/7 to assist you with any technical issues or questions. We are committed to providing you with the support you need to ensure smooth and efficient cloud operations.",
    },
    {
      imgSrc: "cloudCost.webp",
      alt: "Cost Efficiency",
      title: "Cost Efficiency",
      description:
        "Reduce capital expenditure by leveraging our pay-as-you-go cloud services. Only pay for the resources you use, allowing you to optimize costs and allocate budget to other critical areas of your business.",
    },
  ],
  serviceSection: [
    {
      title: "Cloud Hosting",
      description:
        "Host your websites and applications on our high-performance cloud servers. Benefit from faster load times, improved performance, and seamless scalability.",
      iconKey: "FaCloud",
    },
    {
      title: "Cloud Storage",
      description:
        "Store, access, and manage your data with ease using our secure cloud storage solutions. Enjoy scalable storage options and robust data protection features.",
      iconKey: "FaDatabase",
    },
    {
      title: "Disaster Recovery",
      description:
        "Protect your business from unexpected disruptions with our cloud-based disaster recovery solutions. Ensure quick recovery and minimal downtime in case of data loss or system failures.",
      iconKey: "FaRedo",
    },
    {
      title: "Cloud Backup",
      description:
        "Automate your data backup processes with our reliable cloud backup services. Safeguard your critical data and restore it quickly when needed.",
      iconKey: "FaSave",
    },
    {
      title: "Software as a Service (SaaS)",
      description:
        "Access a wide range of software applications on a subscription basis without the need for installation or maintenance. Simplify software management and reduce costs with our SaaS offerings.",
      iconKey: "FaCogs",
    },
    {
      title: "Infrastructure as a Service (IaaS)",
      description:
        "Build and manage your IT infrastructure with our flexible IaaS solutions. Customize your virtual machines, storage, and networking resources to suit your business needs.",
      iconKey: "FaServer",
    },
  ],
  howItWorks: [
    {
      step: "1",
      title: "Consultation",
      description:
        "Contact us to discuss your cloud requirements. Our experts will assess your needs and recommend the best cloud solutions for your business.",
    },
    {
      step: "2",
      title: "Implementation",
      description:
        "We assist with the deployment and configuration of your cloud environment, ensuring a smooth transition and minimal disruption to your operations.",
    },
    {
      step: "3",
      title: "Management and Support",
      description:
        "Enjoy 24/7 cloud management, monitoring, and maintenance to ensure your systems run smoothly.",
    },
    {
      step: "4",
      title: "Optimization",
      description:
        "Continuously optimize your cloud resources to ensure maximum performance and cost-efficiency. Our team provides insights and recommendations to help you get the most out of your cloud investment.",
    },
  ],
  faq: [
    {
      question: "What cloud models does QuantaRock offer?",
      answer:
        "We offer public, private, and hybrid cloud solutions tailored to your security and scalability requirements.",
    },
    {
      question: "How does cloud computing reduce costs?",
      answer:
        "Cloud services operate on a pay-as-you-go model. You only pay for the resources you use, eliminating upfront infrastructure costs.",
    },
    {
      question: "Is my data secure in the cloud?",
      answer:
        "Yes, our cloud infrastructure includes encryption, firewalls, regular security audits, and compliance with industry standards to protect your data.",
    },
    {
      question: "Can I migrate existing systems to the cloud?",
      answer:
        "Absolutely. We provide seamless migration services with minimal downtime and zero data loss.",
    },
    {
      question: "Colocation vs cloud hosting — which should I choose?",
      answer:
        "Colocation gives you full control over your own hardware and predictable long-term costs, making it ideal for stable, compliance-sensitive workloads. Cloud hosting is better for variable or fast-growing workloads that need to scale in minutes. Many businesses use both — colocating stable core systems while using cloud for bursty demand.",
    },
  ],
};
export const CERTIFICATIONS_COMPLIANCES = {
  title: "Certifications & Compliances",
  description:
    "Welcome to QuantaRock Systems, where we prioritize the highest standards of reliability, security, and compliance for your datacenter and hosting needs. In today's digital era, maintaining compliance and achieving the necessary certifications is crucial for safeguarding your business operations and data integrity.",
  serviceTitle: "Our Certification and Compliance Services",
  serviceSubTitle:
    "At QuantaRock Systems, we offer comprehensive services to help you achieve and maintain the necessary certifications and compliance for your datacenter and hosting operations",
  detailSectionTitle: "How We Help",
  detailSectionSubTitle: "Ways We Support You",
  whyChooseUs: [
    {
      imgSrc: "compliance.webp",
      alt: "Regulatory Compliance",
      title: "Regulatory Compliance",
      description:
        "Stay compliant with industry regulations and legal requirements, avoiding potential fines and legal issues that can arise from non-compliance.",
    },
    {
      imgSrc: "trust.webp",
      alt: "Customer Trust",
      title: "Customer Trust",
      description:
        "Certifications provide assurance to your clients that their data is handled with the utmost care and in compliance with international standards.",
    },
    {
      imgSrc: "operationalEfficiency.webp",
      alt: "Operational Efficiency",
      title: "Operational Efficiency",
      description:
        "Compliance with industry standards often leads to improved operational processes, reducing risks and enhancing overall efficiency.",
    },
    {
      imgSrc: "security.webp",
      alt: "Enhanced Security",
      title: "Enhanced Security",
      description:
        "Certifications ensure that your datacenter and hosting services meet rigorous security standards, protecting your sensitive data from threats and breaches.",
    },
    {
      imgSrc: "hand.webp",
      alt: "Expert Support",
      title: "Expert Support",
      description:
        "Our experienced cloud professionals are available 24/7 to assist you with any technical issues or questions. We are committed to providing you with the support you need to ensure smooth and efficient cloud operations.",
    },
    {
      imgSrc: "trophy.webp",
      alt: "Competitive Advantage",
      title: "Competitive Advantage",
      description:
        "Achieving certifications sets you apart from competitors, showcasing your commitment to excellence and adherence to best practices.",
    },
  ],
  serviceSection: [
    {
      title: "ISO 27001",
      description:
        "Achieve the internationally recognized standard for information security management systems (ISMS), ensuring robust security controls and risk management practices.",
      iconKey: "FaShieldAlt",
    },
    {
      title: "PCI DSS",
      description:
        "Comply with the Payment Card Industry Data Security Standard (PCI DSS) to protect cardholder data and secure payment transactions.",
      iconKey: "FaCreditCard",
    },
    {
      title: "HIPAA",
      description:
        "Ensure compliance with the Health Insurance Portability and Accountability Act (HIPAA) for handling sensitive healthcare information.",
      iconKey: "FaUserMd",
    },
    {
      title: "SOC 2",
      description:
        "Demonstrate your commitment to security, availability, processing integrity, confidentiality, and privacy with SOC 2 compliance.",
      iconKey: "FaLock",
    },
    {
      title: "GDPR",
      description:
        "Comply with the General Data Protection Regulation (GDPR) to protect the personal data and privacy of EU citizens.",
      iconKey: "FaUserShield",
    },
  ],
  howItWorks: [
    {
      step: "1",
      title: "Assessment",
      description:
        "We conduct thorough assessments of your current infrastructure and processes to identify gaps and areas for improvement in compliance and security.",
    },
    {
      step: "2",
      title: "Implementation",
      description:
        "Our experts assist you in implementing the necessary controls, policies, and procedures to meet certification and compliance requirements.",
    },
    {
      step: "3",
      title: "Training",
      description:
        "We provide comprehensive training for your staff to ensure they understand and adhere to compliance standards and best practices.",
    },
    {
      step: "4",
      title: "Audit Support",
      description:
        "Our team supports you throughout the audit process, helping you prepare for and successfully pass certification audits.",
    },
  ],
  faq: [
    {
      question: "Why is compliance important for businesses?",
      answer:
        "Compliance ensures legal protection, avoids fines, builds customer trust, and demonstrates commitment to security and data protection.",
    },
    {
      question: "What certifications does QuantaRock help achieve?",
      answer:
        "We help with ISO 27001, PCI DSS, HIPAA, SOC 2, GDPR, and other industry-specific compliance requirements.",
    },
    {
      question: "How long does the certification process take?",
      answer:
        "Timeline varies by certification. We provide a detailed timeline after assessment. Typically, it ranges from 2-6 months.",
    },
    {
      question: "Do you provide ongoing compliance support?",
      answer:
        "Yes, we provide continuous monitoring, updates, and support to maintain your certifications and ensure ongoing compliance.",
    },
  ],
};
export const ENGINEERS_SERVICE = {
  title: "Engineers Services",
  description:
    "At QuantaRock Systems, we offer top-notch engineering services designed to meet the diverse needs of our clients in the IT and hosting industry. Our team of skilled engineers brings a wealth of knowledge and experience, ensuring that your projects are handled with the highest level of expertise and professionalism.",
  serviceTitle: "Our Engineering Services",
  serviceSubTitle: "Expert Solutions for Your Technical Needs",
  detailSectionTitle: "How We Help",
  detailSectionSubTitle: "Ways We Support You",
  whyChooseUs: [
    {
      imgSrc: "expert.webp",
      alt: "Expertise",
      title: "Expertise",
      description:
        "Our engineers are highly qualified and experienced, equipped with the latest skills and knowledge in the IT and hosting domains.",
    },
    {
      imgSrc: "customization.webp",
      alt: "Customization",
      title: "Customization",
      description:
        "We tailor our services to meet your specific requirements, ensuring that you receive solutions that are perfectly aligned with your business goals.",
    },
    {
      imgSrc: "reliability.webp",
      alt: "Reliability",
      title: "Reliability",
      description:
        "Depend on us for reliable and consistent support, ensuring your projects are completed on time and within budget.",
    },
    {
      imgSrc: "innovation.webp",
      alt: "Innovation",
      title: "Innovation",
      description:
        "Stay ahead of the competition with innovative solutions that leverage the latest technologies and industry best practices.",
    },
    {
      imgSrc: "scalability.webp",
      alt: "Scalability",
      title: "Scalability",
      description:
        "Easily scale our engineering services to match the growth and evolving needs of your business.",
    },
  ],
  serviceSection: [
    {
      title: "System Design and Architecture",
      description:
        "Crafting robust and scalable IT infrastructure solutions tailored to your business requirements.",
      iconKey: "FaProjectDiagram",
    },
    {
      title: "Network Engineering",
      description:
        "Designing, implementing, and managing advanced network solutions to ensure seamless connectivity and performance.",
      iconKey: "FaNetworkWired",
    },
    {
      title: "Data Center Engineering",
      description:
        "Providing expert guidance and support for the design, setup, and optimization of data center environments.",
      iconKey: "FaServer",
    },
    {
      title: "Cloud Engineering",
      description:
        "Assisting with the planning, deployment, and management of cloud solutions to enhance your operational efficiency.",
      iconKey: "FaCloud",
    },
    {
      title: "Cybersecurity Engineering",
      description:
        "Implementing cutting-edge security measures to protect your IT infrastructure from potential threats.",
      iconKey: "FaShieldAlt",
    },
    {
      title: "Software Engineering",
      description:
        "Developing custom software solutions that drive innovation and streamline your business processes.",
      iconKey: "FaCode",
    },
  ],
  howItWorks: [
    {
      step: "1",
      title: "Consultation",
      description:
        "Conducting detailed consultations to understand your specific engineering needs and challenges.",
    },
    {
      step: "2",
      title: "Planning",
      description:
        "Developing comprehensive plans and strategies to address your engineering requirements effectively.",
    },
    {
      step: "3",
      title: "Implementation",
      description:
        "Executing projects with precision and efficiency, ensuring minimal disruption to your operations.",
    },
    {
      step: "4",
      title: "Support",
      description:
        "Providing ongoing support and maintenance to ensure the longevity and reliability of your engineering solutions.",
    },
  ],
  faq: [
    {
      question: "What engineering services does QuantaRock offer?",
      answer:
        "We provide system design, network engineering, data center engineering, cloud engineering, cybersecurity engineering, and software engineering.",
    },
    {
      question: "Can you help design a custom IT infrastructure?",
      answer:
        "Yes, our engineers design robust, scalable IT infrastructure tailored to your business requirements and growth plans.",
    },
    {
      question: "How do you ensure high availability and disaster recovery?",
      answer:
        "We design redundant systems, implement failover mechanisms, and create comprehensive disaster recovery plans.",
    },
    {
      question: "What is your experience with data center design?",
      answer:
        "Our engineers have extensive experience designing secure, efficient data centers with optimal power, cooling, and connectivity.",
    },
  ],
};
export const SOFTWARE_DEVELOPMENT = {
  title: "Software Services",
  description:
    "At QuantaRock Systems, we offer comprehensive software services tailored to meet the dynamic needs of our clients in the IT and hosting industry. Our team of skilled software developers and engineers is committed to delivering high-quality solutions that enhance your business operations and drive growth.",
  serviceTitle: "Our Software Services",
  serviceSubTitle: "Innovative Solutions for Your Software Needs",
  detailSectionTitle: "How We Help",
  detailSectionSubTitle: "Ways We Support You",
  whyChooseUs: [
    {
      imgSrc: "softwareExpert.webp",
      alt: "Expertise",
      title: "Expertise",
      description:
        "Our developers are proficient in the latest technologies and methodologies, ensuring top-notch software solutions.",
    },
    {
      imgSrc: "softwareCustom.webp",
      alt: "Customization",
      title: "Customization",
      description:
        "We provide personalized software solutions that align with your specific business requirements.",
    },
    {
      imgSrc: "softwareReliability.webp",
      alt: "Reliability",
      title: "Reliability",
      description:
        "Depend on our reliable and efficient software services to support your business needs.",
    },
    {
      imgSrc: "softwareInnovation.webp",
      alt: "Innovation",
      title: "Innovation",
      description:
        "Stay ahead with innovative software that leverages cutting-edge technology and industry best practices.",
    },
    {
      imgSrc: "softwareScalability.webp",
      alt: "Scalability",
      title: "Scalability",
      description:
        "Easily scale our software solutions to match the growth and evolving demands of your business.",
    },
  ],
  serviceSection: [
    {
      title: "Custom Software Development",
      description:
        "Creating bespoke software solutions that are tailored to your unique business processes.",
      iconKey: "FaCode",
    },
    {
      title: "Web Application Development",
      description:
        "Building robust and scalable web applications that enhance your online presence and functionality.",
      iconKey: "FaGlobe",
    },
    {
      title: "Mobile Application Development",
      description:
        "Developing user-friendly mobile apps for various platforms to engage your customers on the go.",
      iconKey: "FaMobileAlt",
    },
    {
      title: "Software Integration",
      description:
        "Seamlessly integrating new software with your existing systems to ensure smooth operations.",
      iconKey: "FaPuzzlePiece",
    },
    {
      title: "Software Maintenance and Support",
      description:
        "Providing ongoing maintenance and support to keep your software up-to-date and running smoothly.",
      iconKey: "FaTools",
    },
    {
      title: "Cloud-Based Solutions",
      description:
        "Developing cloud-based software solutions that offer flexibility and scalability for your business.",
      iconKey: "FaCloud",
    },
  ],
  howItWorks: [
    {
      step: "1",
      title: "Consultation",
      description:
        "Understanding your specific software needs through detailed consultations.",
    },
    {
      step: "2",
      title: "Planning",
      description:
        "Developing comprehensive plans and strategies for your software projects.",
    },
    {
      step: "3",
      title: "Development",
      description:
        "Building high-quality software solutions that meet your business requirements.",
    },
    {
      step: "4",
      title: "Testing",
      description:
        "Rigorous testing to ensure the reliability and performance of your software.",
    },
    {
      step: "5",
      title: "Deployment",
      description:
        "Smooth deployment of software solutions with minimal disruption to your operations.",
    },
    {
      step: "6",
      title: "Support",
      description:
        "Providing ongoing support and updates to ensure the continued success of your software.",
    },
  ],
  faq: [
    {
      question: "What software development methodologies do you use?",
      answer:
        "We use Agile, Scrum, and other proven methodologies to ensure rapid development, quality, and timely delivery.",
    },
    {
      question: "Can you build custom software for my specific business needs?",
      answer:
        "Absolutely. We specialize in custom software development tailored to your unique business processes and requirements.",
    },
    {
      question: "Do you provide post-launch support?",
      answer:
        "Yes, we provide 24/7 monitoring, maintenance, bug fixes, updates, and feature enhancements after launch.",
    },
    {
      question: "How do you ensure software quality?",
      answer:
        "We conduct rigorous testing (unit, integration, UAT), code reviews, and follow best practices to ensure high-quality software.",
    },
  ],
};
export const PRI_SOLUTIONS = {
  title: "PRI Solutions",
  description:
    "Experience the best-in-class PRI services tailored to meet your business needs. Whether you're in Indore or anywhere across India, our scalable, secure, and reliable PRI solutions will ensure your communication needs are met with the highest standards.",
  serviceTitle: "Our Unique Selling Propositions (USP)",
  serviceSubTitle: "Innovative Solutions for Your PRI Services",
  detailSectionTitle: "How We Help",
  detailSectionSubTitle:
    "Contact us today to discuss your PRI service requirements and discover how we can help optimize your business communication!",
  whyChooseUs: [
    {
      imgSrc: "customizableSolutions.webp",
      alt: "Customizable Solutions for Your Business",
      title: "Customizable Solutions for Your Business",
      description:
        "Whether you need a PRI line for voice calls or integrated voice and data services, we offer flexible solutions that align with your business goals.",
    },
    {
      imgSrc: "scalableInfraPRI.webp",
      alt: "Scalable Infrastructure",
      title: "Scalable Infrastructure",
      description:
        "As your business grows, our services scale seamlessly. We ensure your communication infrastructure can keep up with your evolving needs.",
    },
    {
      imgSrc: "reliableSupportPRI.webp",
      alt: "Reliable Customer Support",
      title: "Reliable Customer Support",
      description:
        "Our dedicated support team is available 24/7 to resolve any issues quickly, ensuring smooth operations at all times.",
    },
    {
      imgSrc: "innovationPRI.webp",
      alt: "Innovation",
      title: "Innovation",
      description:
        "Stay ahead with innovative software that leverages cutting-edge technology and industry best practices.",
    },
    {
      imgSrc: "costPRI.webp",
      alt: "Cost-Effective Pricing",
      title: "Cost-Effective Pricing",
      description:
        "With competitive rates and the ability to choose from multiple ISPs, we provide cost-effective solutions that help reduce your communication expenses.",
    },
    {
      imgSrc: "trustPRI.webp",
      alt: "Trusted by Major Clients in Indore",
      title: "Trusted by Major Clients in Indore",
      description:
        "We are proud to be the trusted PRI service provider for several high-profile clients in Indore, demonstrating our expertise in delivering results for businesses of all sizes.",
    },
  ],
  serviceSection: [
    {
      title: "End-to-End Solutions",
      description:
        "From installation to ongoing support, we handle every aspect of your PRI service, allowing you to focus on running your business while we manage the technical side.",
      iconKey: "FaTasks",
    },
    {
      title: "Robust Network Infrastructure",
      description:
        "We use state-of-the-art network infrastructure in our data centers, providing unmatched reliability and scalability.",
      iconKey: "FaNetworkWired",
    },
    {
      title: "Local Expertise with National Reach",
      description:
        "Developing user-While our roots are in Indore, we provide services across India, ensuring you get local support with the advantages of national coverage.",
      iconKey: "FaMapMarkerAlt",
    },
    {
      title: "User-Centric Experience",
      description:
        " Our services are designed with the end-user in mind, ensuring that you have a seamless, uninterrupted experience, from setup to usage.",
      iconKey: "FaUser",
    },
    {
      title: "High-Quality Voice & Data Integration",
      description:
        "Our PRI services provide seamless integration of voice and data, allowing businesses to enhance communication while improving operational efficiency across departments.",
      iconKey: "FaPhoneAlt",
    },
    {
      title: "Scalable & Flexible Solutions",
      description:
        "Whether you're expanding your business or need tailored solutions, our PRI services are highly scalable and flexible, adjusting to your needs as your business grows.",
      iconKey: "FaExpandArrowsAlt",
    },
  ],
  howItWorks: [
    {
      step: "1",
      title: "Consultation",
      description:
        "We begin with a detailed consultation to understand your business communication needs and design a tailored PRI solution for your organization.",
    },
    {
      step: "2",
      title: "Network Design & Planning",
      description:
        "Our experts create a robust and scalable PRI architecture, taking into account your current needs and future growth in data center environments.",
    },
    {
      step: "3",
      title: "Installation & Configuration",
      description:
        "We handle the full installation of PRI lines, ensuring seamless integration with your existing infrastructure and configuring it to maximize performance.",
    },
    {
      step: "4",
      title: "Testing & Optimization",
      description:
        "Before going live, we conduct rigorous testing to ensure high-quality voice and data integration, optimizing for maximum reliability and minimal latency.",
    },
    {
      step: "5",
      title: "Deployment & Integration",
      description:
        "Once tested, we deploy and integrate the PRI solution into your data center, ensuring seamless communication across your entire network.",
    },
    {
      step: "6",
      title: "Ongoing Support & Maintenance",
      description:
        "Our dedicated support team ensures continuous monitoring, maintenance, and troubleshooting, allowing your business to operate with uninterrupted PRI services.",
    },
  ],
  faq: [
    {
      question: "What is a PRI (Primary Rate Interface)?",
      answer:
        "PRI is a telecommunications standard providing integrated voice and data communication over multiple digital channels, ideal for business communication.",
    },
    {
      question: "How many channels does a PRI line provide?",
      answer:
        "A standard PRI provides 23 B-channels (voice/data) and 1 D-channel (signaling), allowing multiple simultaneous calls.",
    },
    {
      question: "Is PRI suitable for small businesses?",
      answer:
        "Yes, PRI is scalable and cost-effective for businesses of all sizes, from startups to enterprises.",
    },
    {
      question: "What support does QuantaRock provide for PRI services?",
      answer:
        "We provide 24/7 monitoring, maintenance, troubleshooting, network optimization, and dedicated technical support.",
    },
  ],
};
export const SERVICES_DATA = {
  IT_CONSULTATION: IT_CONSULTATION_DATA,
  RENTAL_HARDWARE: RENTAL_HARDWARE,
  SECURITY_AS_SERVICE: SECURITY_AS_SERVICE,
  COLOCATION_SERVICES: COLOCATION_SERVICES,
  DEDICATED_SERVERS: DEDICATED_SERVERS,
  VPS_SERVICES: VPS_SERVICES,
  CLOUD_SERVICES: CLOUD_SERVICES,
  CERTIFICATIONS_COMPLIANCES: CERTIFICATIONS_COMPLIANCES,
  ENGINEERS_SERVICE: ENGINEERS_SERVICE,
  SOFTWARE_DEVELOPMENT: SOFTWARE_DEVELOPMENT,
  PRI_SOLUTIONS: PRI_SOLUTIONS,
};
export const ALL_DETAIL_ROUTES_INFO = [SERVICES_DATA];
